/**
 * @author frank.zhang
 * @date 2022/06/28
 */

window.EventDelegationUtil = class {
  constructor() {}

  /**
   * Example: onSelector('.product-list', 'click', '.product-item', function(e) {})
   * @param {string} selector
   * @param {string} event
   * @param {string} watch
   * @param {function} handler
   * @param {string[]} excludeSelector
   */
  static on(el, event, watch, handler, ...excludeSelector) {
    if (typeof el === 'string') {
      el = document.querySelector(el);
    }
    if (!el) {
      return;
    }
    el.addEventListener(event, function (e) {
      let target = e.target;
      while (target != e.currentTarget.parentNode) {
        if (excludeSelector.some((d) => target.matches(d))) {
          return;
        }
        if (target.matches(watch)) {
          handler.call(target, e);
          return;
        }
        target = target.parentNode;
      }
      // console.warn(`Can not find Selector \`${watch}\`  in Node: `, el);
    });
  }
};

/**
 * @author frank.zhang
 * @date 2022/07/01
 */
window.UniEventBus = (function () {
  const handlerMap = {};
  const providerMap = {};
  return {
    /**
     * subscribe a event
     * @param {*} name
     * @param {*} callback
     */
    on(name, callback) {
      const handlers = handlerMap[name] || [];
      handlers.push(callback);
      handlerMap[name] = handlers;
    },

    /**
     * cancel a subscribe for an event
     * @param {*} name
     * @param {*} callback
     */
    off(name, callback) {
      const handlers = handlerMap[name] || [];
      handlerMap[name] = handlers.filter((d) => d !== callback);
    },

    /**
     * cancel all subscribe for an event
     * @param {*} name
     */
    offAll(name) {
      handlerMap[name] = [];
    },

    /**
     * publisher a event
     * @param {*} name
     * @param  {...any} args
     */
    submit(name, ...args) {
      const handlers = handlerMap[name] || [];
      handlers.forEach((cb) => cb(...args));
    },

    /**
     * register a data provider
     * @param {*} name
     * @param {*} provider
     */
    registerProvider(name, provider) {
      providerMap[name] = provider;
    },

    /**
     * pull data by name
     * @param {*} name
     * @param  {...any} args
     * @returns data
     */
    pullData(name, ...args) {
      if (providerMap[name]) {
        return providerMap[name](...args);
      }
    },
  };
})();


